// Cookie consent helpers. Consent is stored in localStorage and respected on
// subsequent visits. Non-essential (analytics/marketing) cookies are only
// activated AFTER consent — see the PostHog guard in public/index.html.
const KEY = "rh_cookie_prefs";

export function getCookiePrefs() {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) {}
  return null; // null = no decision recorded yet
}

export function saveCookiePrefs(prefs) {
  const full = {
    necessary: true, // always on, cannot be disabled
    analytics: !!prefs.analytics,
    marketing: !!prefs.marketing,
    savedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(full));
  } catch (e) {}
  return full;
}

export function hasAnalyticsConsent() {
  const p = getCookiePrefs();
  return !!(p && p.analytics);
}
